document.addEventListener('DOMContentLoaded', function () {

    const popup = document.getElementById('postcode-popup');
    const postcodeInput = document.getElementById('delivery-postcode');
    const checkButton = document.getElementById('check-postcode');
    const closeButton = document.getElementById('close-postcode-popup');
    const changeButton = document.getElementById('change-postcode');

    const resultMessage = document.getElementById('deliveryValidationMessage');

    // IMPORTANT:
    // Use your existing allowed postcode list here.
    const ALLOWED_POSTCODES = [
        '2000',
        '2007',
        '2008',
        '2010',
        '2011',
        '2015',
        '2016',
        '2017',
        '2018',
        '2019',
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
        '2026',
        '2027',
        '2028',
        '2029',
        '2030',
        '2031',
        '2032',
        '2033',
        '2034',
        '2035',
        '2036',
        '2037',
        '2038',
        '2039',
        '2040',
        '2041',
        '2042',
        '2043',
        '2044',
        '2045',
        '2046',
        '2047',
        '2048',
        '2049',
        '2050',
        '2060',
        '2061',
        '2062',
        '2063',
        '2064',
        '2065',
        '2066',
        '2067',
        '2068',
        '2069',
        '2070',
        '2071',
        '2072',
        '2073',
        '2074',
        '2075',
        '2076',
        '2077',
        '2079',
        '2080',
        '2081',
        '2082',
        '2083',
        '2084',
        '2085',
        '2086',
        '2087',
        '2088',
        '2089',
        '2090',
        '2091',
        '2092',
        '2093',
        '2094',
        '2095',
        '2096',
        '2097',
        '2099',
        '2100',
        '2101',
        '2102',
        '2103',
        '2104',
        '2105',
        '2106',
        '2107',
        '2108',
        '2109',
        '2110',
        '2111',
        '2112',
        '2113',
        '2114',
        '2115',
        '2116',
        '2117',
        '2118',
        '2119',
        '2120'
    ];

    const STORAGE_KEY = 'delivery_postcode';

    /*
     * ---------------------------------------------------------
     * INITIAL LOAD
     * ---------------------------------------------------------
     */

    const savedPostcode = localStorage.getItem(STORAGE_KEY);

    if (savedPostcode) {

        // Customer already selected a postcode.
        // DO NOT show popup.
        if (popup) {
            popup.style.display = 'none';
        }

        updateDeliveryDisplay(savedPostcode);

    } else {

        // First visit - show popup.
        if (popup) {
            popup.style.display = 'flex';
        }
    }


    /*
     * ---------------------------------------------------------
     * CHECK POSTCODE
     * ---------------------------------------------------------
     */

    if (checkButton) {

        checkButton.addEventListener('click', function () {

            const postcode = postcodeInput
                ? postcodeInput.value.trim()
                : '';

            if (!postcode) {

                showMessage(
                    'Please enter your postcode.',
                    'error'
                );

                return;
            }

            if (!/^\d{4}$/.test(postcode)) {

                showMessage(
                    'Please enter a valid 4-digit postcode.',
                    'error'
                );

                return;
            }

            if (ALLOWED_POSTCODES.includes(postcode)) {

                // Save postcode
                localStorage.setItem(
                    STORAGE_KEY,
                    postcode
                );

                // Save timestamp
                localStorage.setItem(
                    'delivery_postcode_checked_at',
                    Date.now()
                );

                showMessage(
                    'Great! We deliver to ' + postcode + '.',
                    'success'
                );

                updateDeliveryDisplay(postcode);

                // Close popup after successful validation
                setTimeout(function () {

                    if (popup) {
                        popup.style.display = 'none';
                    }

                }, 800);

            } else {

                // Invalid postcode
                localStorage.removeItem(STORAGE_KEY);

                showMessage(
                    'Sorry, we currently do not deliver to this postcode.',
                    'error'
                );
            }

        });
    }


    /*
     * ---------------------------------------------------------
     * CLOSE POPUP
     * ---------------------------------------------------------
     */

    if (closeButton) {

        closeButton.addEventListener('click', function () {

            if (localStorage.getItem(STORAGE_KEY)) {

                popup.style.display = 'none';

            } else {

                // Don't allow closing permanently
                // if postcode has never been checked.
                showMessage(
                    'Please check your postcode before continuing.',
                    'error'
                );
            }

        });
    }


    /*
     * ---------------------------------------------------------
     * CHANGE POSTCODE
     * ---------------------------------------------------------
     */

    if (changeButton) {

        changeButton.addEventListener('click', function () {

            const savedPostcode =
                localStorage.getItem(STORAGE_KEY);

            if (postcodeInput) {

                postcodeInput.value =
                    savedPostcode || '';

            }

            if (popup) {

                popup.style.display = 'flex';

            }

            if (postcodeInput) {

                setTimeout(function () {

                    postcodeInput.focus();

                }, 100);

            }

        });
    }


    /*
     * ---------------------------------------------------------
     * SHOW MESSAGE
     * ---------------------------------------------------------
     */

    function showMessage(message, type) {

        if (!resultMessage) {
            return;
        }

        resultMessage.textContent = message;

        resultMessage.className =
            'delivery-validation-message ' + type;

    }


    /*
     * ---------------------------------------------------------
     * UPDATE HEADER / DELIVERY DISPLAY
     * ---------------------------------------------------------
     */

    function updateDeliveryDisplay(postcode) {

        const deliveryDisplay =
            document.getElementById('selected-delivery-postcode');

        if (deliveryDisplay) {

            deliveryDisplay.innerHTML =
                '✓ Delivery to <strong>' +
                postcode +
                '</strong>';

        }

        const changePostcodeLink =
            document.getElementById('change-postcode');

        if (changePostcodeLink) {

            changePostcodeLink.style.display =
                'inline-block';

        }
    }

});

